import $ from 'jquery';
import carousels from '../framework/carousel';

$('.media-carousel').each((index, item) => {
  const parentId = $(item).attr('id');
  const customMediaCarouselSettings = $(item).data();
  const mediaCarouselSettings = {
    autoplay: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    ...customMediaCarouselSettings,
  };

  const mediaCarouselImages = carousels(`#${parentId}-images`, {
    ...mediaCarouselSettings,
    asNavFor: `#${parentId}-content`,
  });

  const mediaCarouselContent = carousels(`#${parentId}-content`, {
    ...mediaCarouselSettings,
    asNavFor: `#${parentId}-images`,
    arrows: false,
  });
});
